window.addEventListener('DOMContentLoaded', function() {
  /* Variant Specs */
  document.addEventListener('variant:change', function(e) {
    const selectedSpec = document.querySelector('.product-form--specs.selected');
    if(selectedSpec) {
      selectedSpec.classList.remove('selected');
    }

    const newSpec = document.querySelector(`.product-form--specs[data-variant-id="${e.detail.variant.id}"]`);
    if(newSpec) {
      newSpec.classList.add('selected');
    }
  });
  
  /* Popup quote */
  const popupContainers = document.querySelectorAll('.rao-contact--popup');
  const requestQuoteButtons = document.querySelectorAll('.quote-button');

  for(const requestQuoteButton of requestQuoteButtons) {
    if(requestQuoteButton.dataset.popupId) {
      const popupContainer = document.querySelector(`.rao-contact--popup-${requestQuoteButton.dataset.popupId}`);
      if(popupContainer) {
        requestQuoteButton.addEventListener('click', function() {
          popupContainer.classList.add('open');
          document.documentElement.classList.add('lock-all');
        });
      }
    }
  }

  for(const popupContainer of popupContainers) {
    const closeButton = popupContainer.querySelector('.rao-contact__popup--close');

    closeButton.addEventListener('click', function() {
      popupContainer.classList.remove('open');
      document.documentElement.classList.remove('lock-all');
    });

    /* Dynamic Logics */
    /* Variant Title */
    const variantTitles = popupContainer.querySelectorAll('input[data-input-id=variant_title]');

    window.addEventListener('variant:change', function(e) {
      for(const variantTitle of variantTitles) {
        variantTitle.value = e.detail.variant.title;
      }
    });

    /* Form Submit */
    const form = popupContainer.querySelector('form');
    form.addEventListener('submit', function(e) {
      console.log(e);
      e.preventDefault();
    });
  }
});